import React from 'react';
import { Bathroom } from '../../../api/listings-client';

interface FacilitiesStepProps {
    parking: boolean | null;
    setParking: (parking: boolean) => void;
    bathrooms: Bathroom | null;
    setBathrooms: (bathrooms: Bathroom) => void;
    furnished: boolean | null;
    setFurnished: (furnished: boolean) => void;
    editMode: boolean;
}

const FacilitiesStep: React.FC<FacilitiesStepProps> = ({
    parking,
    setParking,
    bathrooms,
    setBathrooms,
    furnished,
    setFurnished,
    editMode = false
}) => {
    const buttonClasses = (isActive: boolean): string =>
        `py-3 px-4 inline-flex items-center justify-center text-base font-medium focus:z-10 ${
            isActive
                ? 'bg-gray-200 shadow-sm border-gray-200 text-[#2476f2] border'
                : 'border border-gray-200 bg-white text-gray-800 shadow-sm bg-gradient-to-br from-[#24ccf2]/0 via-[#2476f2]/0 to-purple-500/0 hover:from-[#24ccf2]/10 hover:via-[#2476f2]/10 hover:to-purple-500/10 '
        } ${isActive ? 'disabled:opacity-100' : 'disabled:opacity-50 disabled:pointer-events-none'}`;

    return (
        <div className="w-full max-w-3xl mx-auto px-4">
            {!editMode && (
                <h1 className="text-2xl font-bold text-gray-800 sm:text-4xl mb-8 text-center">
                    Tell us more about the room
                </h1>
            )}
            
            <div className="space-y-6">
                {/* Bathroom */}
                <div className="space-y-2">
                    <div className="text-lg font-medium text-gray-700">
                        Bathroom
                    </div>
                    <div className="inline-flex rounded-lg shadow-sm">
                        <button
                            type="button"
                            className={`${buttonClasses(bathrooms === Bathroom.SHARED)} rounded-s-lg w-24`}
                            onClick={() => setBathrooms(Bathroom.SHARED)}
                        >
                            Shared
                        </button>
                        <button
                            type="button"
                            className={`${buttonClasses(bathrooms === Bathroom.OWN)} -ms-px rounded-e-lg w-24`}
                            onClick={() => setBathrooms(Bathroom.OWN)}
                        >
                            Private
                        </button>
                    </div>
                </div>

                {/* Furnished */}
                <div className="space-y-2">
                    <div className="text-lg font-medium text-gray-700">
                        Furnished
                    </div>
                    <div className="inline-flex rounded-lg shadow-sm">
                        <button
                            type="button"
                            className={`${buttonClasses(furnished === true)} rounded-s-lg w-20`}
                            onClick={() => setFurnished(true)}
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            className={`${buttonClasses(furnished === false)} -ms-px rounded-e-lg w-20`}
                            onClick={() => setFurnished(false)}
                        >
                            No
                        </button>
                    </div>
                </div>

                {/* Parking */}
                <div className="space-y-2">
                    <div className="text-lg font-medium text-gray-700">
                        Parking
                    </div>
                    <div className="inline-flex rounded-lg shadow-sm">
                        <button
                            type="button"
                            className={`${buttonClasses(parking === true)} rounded-s-lg w-20`}
                            onClick={() => setParking(true)}
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            className={`${buttonClasses(parking === false)} -ms-px rounded-e-lg w-20`}
                            onClick={() => setParking(false)}
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FacilitiesStep;